/**
 * Workspace onboarding wizard — English catalog slice.
 * Keeps existing merchant-facing wording; new UI chrome goes through t().
 */
export const enOnboarding = {
  'onboarding.subtitle': "Let's get your business set up in minutes",
  'onboarding.skipSetup': 'Skip setup',
  'onboarding.stepOf': 'Step {current} of {total}',
  'onboarding.steps.aria': 'Onboarding progress',
  'onboarding.steps.business': 'Business',
  'onboarding.steps.connect': 'Connect',
  'onboarding.steps.brand': 'Brand',
  'onboarding.steps.ready': 'Ready',
  'onboarding.back': 'Back',
  'onboarding.continue': 'Continue',
  'onboarding.saving': 'Saving…',
  'onboarding.connected': 'Connected',
  'onboarding.connect': 'Connect',

  'onboarding.kind.title': 'What kind of business are you?',
  'onboarding.kind.body':
    'Everything aligns to your answer — triggers, templates, KPIs and the connect step. You can change it later.',
  'onboarding.kind.hint': 'Selected: {kind}. Double-click a card or press Continue.',

  'onboarding.store.title': 'Connect Your Store',
  'onboarding.store.body': 'One-click connection - just log in and approve access.',
  'onboarding.store.errorTitle': 'Connection Failed',
  'onboarding.store.tryAgain': 'Try Again',
  'onboarding.store.dismiss': 'Dismiss',
  'onboarding.store.howTitle': 'How it works',
  'onboarding.store.how1': 'Click platform',
  'onboarding.store.how2': 'Log in',
  'onboarding.store.how3': 'Approve',
  'onboarding.store.howDone': 'Done!',
  'onboarding.store.skip': 'Skip for now',

  'onboarding.brand.title': 'Define Your Brand',
  'onboarding.brand.body': 'Choose your brand voice and color to personalize your messages.',
  'onboarding.brand.voice': 'Brand Voice',
  'onboarding.brand.color': 'Primary Color',
  'onboarding.brand.preview': 'Live preview',
  'onboarding.brand.previewFrom': 'From your business',
  'onboarding.brand.previewNow': 'just now',
  'onboarding.brand.previewCta': 'View details',
  'onboarding.brand.voice.casual': 'Casual',
  'onboarding.brand.voice.casualDesc': 'Friendly and conversational',
  'onboarding.brand.voice.casualSample':
    "Hey! Just a quick note — your order is on its way. Reply anytime if you need us.",
  'onboarding.brand.voice.professional': 'Professional',
  'onboarding.brand.voice.professionalDesc': 'Polished and respectful',
  'onboarding.brand.voice.professionalSample':
    'Hello. Your order has been shipped and is on its way. We are here if you need anything.',
  'onboarding.brand.voice.luxury': 'Luxury',
  'onboarding.brand.voice.luxuryDesc': 'Sophisticated and premium',
  'onboarding.brand.voice.luxurySample':
    'Your order is on its way — crafted with care, delivered with excellence.',
  'onboarding.brand.voice.urgent': 'Urgent',
  'onboarding.brand.voice.urgentDesc': 'Time-sensitive and action-oriented',
  'onboarding.brand.voice.urgentSample':
    'Your order just shipped. Track it now before it arrives.',
  'onboarding.brand.voice.friendly': 'Friendly',
  'onboarding.brand.voice.friendlyDesc': 'Warm and approachable',
  'onboarding.brand.voice.friendlySample':
    "Good news — your order is on the way! We're cheering it along with you.",
  'onboarding.brand.voice.funny': 'Funny',
  'onboarding.brand.voice.funnyDesc': 'Humorous and entertaining',
  'onboarding.brand.voice.funnySample':
    'Your package left the building. We waved. It did not wave back. Track it anyway.',

  'onboarding.setup.title': 'Setting Up Your Workspace',
  'onboarding.setup.body': "We're configuring everything for you...",
  'onboarding.setup.progress': 'Progress',
  'onboarding.setup.step.brand': 'Configuring brand settings',
  'onboarding.setup.step.flows': 'Setting up automation flows',
  'onboarding.setup.step.analytics': 'Initializing analytics',
  'onboarding.setup.step.workspace': 'Preparing your workspace',
  'onboarding.setup.step.final': 'Finalizing your workspace',
  'onboarding.setup.complete': 'Setup Complete! Redirecting...',
  'onboarding.setup.redirect': 'Redirecting to dashboard...',
} as const;
